// extracted by mini-css-extract-plugin
export default {"wrapper":"eG-z","viewport":"fG-z","container":"gG-z","slide":"hG-z"};